import { render, staticRenderFns } from "./review-images-dialog.vue?vue&type=template&id=894a6106&"
import script from "./review-images-dialog.vue?vue&type=script&lang=js&"
export * from "./review-images-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports